module.exports = __webpack_public_path__ + "static/media/gpk_logo_wht.f31df84b.png";


//////////////////
// WEBPACK FOOTER
// ./src/gpk_logo_wht.png
// module id = 43
// module chunks = 0